import React from 'react';
import { motion } from 'framer-motion';

interface StatsSectionProps {
  title: string | React.ReactNode;
  subtitle?: string;
}

export default function StatsSection({
  title,
  subtitle,
}: StatsSectionProps) {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2,
      },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.5, ease: [0.165, 0.84, 0.44, 1] },
    },
  };
  
  return (
    <section className="py-20">
      <div className="container-custom">
        <div className="max-w-3xl mx-auto text-center mb-16">
          <h2 className="section-title">
            {title}
          </h2>
          {subtitle && <p className="text-xl text-neutral-600">{subtitle}</p>}
        </div>
        
        <motion.div 
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8"
          variants={containerVariants}
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true, margin: "-100px" }}
        >
          {[
            { 
              value: "98%", 
              label: "Taux de satisfaction", 
              description: "Clients et candidats confondus" 
            }, 
            { 
              value: "-45%", 
              label: "Temps de recrutement", 
              description: "vs méthodes traditionnelles" 
            }, 
            { 
              value: "50%", 
              label: "Deux entretiens maximum", 
              description: "Pour une embauche" 
            }
          ].map((stat, index) => (
            <motion.div
              key={index}
              variants={itemVariants}
              // Bug fix 2026-05-18 : le pseudo `before:` avec gradient rose
              // en -z-10 (tentative de bordure gradient) fuitait pendant
              // l'animation opacity → carrés roses visibles au scroll.
              // Remplacé par un ring discret qui rend le même effet "carte
              // premium" sans le flash.
              className="text-center p-6 rounded-lg bg-white shadow-lg ring-1 ring-neutral-200"
            >
              <p className="text-4xl md:text-5xl font-bold mb-2 bg-gradient-to-r from-[#d03484] to-[#d47254] bg-clip-text text-transparent">{stat.value}</p>
              <p className="text-xl font-medium text-neutral-800 mb-2">{stat.label}</p>
              {stat.description && <p className="text-neutral-600">{stat.description}</p>}
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}